import styled from 'styled-components';

import { Icon as DefaultIcon } from 'components/UI/Icons/Icon';
import { Dropdown as DefaultDropdown } from 'components/UI/Dropdown';
import { Typography } from 'components/UI/Typography';

export const Dropdown = styled(DefaultDropdown)`
	padding: 0;
	width: auto;
	display: flex;
`;

export const DropdownHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	padding: 1rem;

	:hover {
		> :last-child {
			visibility: visible;
		}
	}
`;

export const DropdownTitle = styled(Typography.Paragraph)`
	padding-left: 1rem;
`;

export const ResetFilterIcon = styled(DefaultIcon)`
	visibility: hidden;
`;
